module.exports = __webpack_public_path__ + "media/images/staging_banner-b0528e485b2b7ce62483b535391d1ead.jpg";